function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "left-nav",
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M34.9093 55C33.2843 55.0029 31.7237 54.493 30.5673 53.5812L1.78383 30.882C1.21875 30.4363 0.770097 29.9055 0.463881 29.3203C0.157665 28.7352 0 28.1072 0 27.473C0 26.8388 0.157665 26.2109 0.463881 25.6257C0.770097 25.0405 1.21875 24.5097 1.78383 24.064L30.451 1.4564C31.6453 0.519127 33.2542 -0.00418922 34.9287 2.52595e-05C36.6031 0.00423974 38.2079 0.535645 39.3948 1.47891C40.5828 2.42981 41.25 3.71821 41.25 5.06148C41.25 6.40474 40.5829 7.69316 39.3949 8.64409L18.0927 25.6566C17.4291 26.1878 17.0563 26.9077 17.0563 27.6581C17.0563 28.4086 17.4291 29.1283 18.0927 29.6596L39.2793 46.5797C40.1445 47.2693 40.7339 48.1484 40.9728 49.1058C41.2118 50.0631 41.0895 51.0556 40.6214 51.9574C40.1534 52.8591 39.3607 53.6297 38.3438 54.1713C37.3269 54.713 36.1316 55.0014 34.9093 55V55Z",
  fill: "#00BFA6"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 41.25,
  height: 55,
  fill: "white"
})));

function SvgLeftNavigationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 55,
    viewBox: "0 0 42 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftNavigationIcon);
export default __webpack_public_path__ + "static/media/left-navigation-icon.82c70742.svg";
export { ForwardRef as ReactComponent };